<template>
  <div class="" :class="[sourceCode === 'aisino' ? 'aisino-box' : 'box']">
    <!--    轮播图-->
    <div class="question" v-if="sourceCode !== 'aisino'">
      <div class="question-box">
        <div class="question-icon">
          <img :src="pc_icon_7" />
        </div>
        <div class="question-detail">
          <p>一年69.9元</p>
          <div class="question-tag">便宜</div>
        </div>
        <div class="question-ts">一年可以问1万个问题。</div>
      </div>
      <div class="question-box">
        <div class="question-icon">
          <img :src="pc_icon_8" />
        </div>
        <div class="question-detail">
          <p>一年69.9元</p>
          <div class="question-two-tag">贴心</div>
        </div>
        <div class="question-ts">一个问题可以反复问，来回问。</div>
      </div>
      <div class="question-box">
        <div class="question-icon">
          <img :src="pc_icon_9" />
        </div>
        <div class="question-detail">
          <p>一年69.9元</p>
          <div class="question-three-tag">专业</div>
        </div>
        <div class="question-ts">500个不同专业的老师等你来提问。</div>
      </div>
    </div>
    <!--在线咨询台-->
    <div
      class=""
      :class="[sourceCode === 'aisino' ? 'aisino-service' : 'service']"
    >
      <chat :tabList="tabList"></chat>
    </div>
  </div>
</template>
<script>
import pc_icon_7 from "@/assets/pc_icon_7.png";
import pc_icon_8 from "@/assets/pc_icon_8.png";
import pc_icon_9 from "@/assets/pc_icon_9.png";
import pc_icon_10 from "@/assets/pc_icon_10.png";
import pc_icon_11 from "@/assets/pc_icon_11.png";
import pc_img_1 from "@/assets/pc_img_1.png";
import chat from "@/components/chat.vue";
import { CHAT_API_DATA } from "@/api/chat";

export default {
  data() {
    return {
      pc_icon_7,
      pc_icon_8,
      pc_icon_9,
      pc_icon_10,
      pc_img_1,
      pc_icon_11,
			sourceCode: "",
			contentList: [],
			tabList: []
    };
  },
  components: {
    chat
  },
  created() {
		this.getIntroduce()
  },
  mounted() {
    this.sourceCode = this.$route.query.sourceCode;
  },
  methods: {
		//介绍
    getIntroduce() {
      CHAT_API_DATA.introduce()
        .then((res) => {
          console.log(res.data);
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].type === 1) {
              this.contentList = res.data[i];
            } else if (res.data[i].type === 3) {
              this.tabList.push(res.data[i]);
            } else if (this.sourceCode !== 'aisino' && res.data[i].type === 2) {
              this.tabList.push(res.data[i]);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
	},
};
</script>
<style lang="scss" scoped>
.box {
  overflow: hidden;
  width: 100%;
  margin-bottom: 20px;
}

.question {
  width: 950px;
  height: 231px;
  background-color: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(194, 200, 211, 0.14);
  border-radius: 10px;
  margin-top: 10px;
  padding: 40px 20px 0px 20px;
}

.question-box {
  width: 280px;
  float: left;
  margin-right: 55px;
}

.question-box:last-child {
  width: 280px;
  float: left;
  margin-right: 0px;
}

.question-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto;
}

.question-icon > img {
  width: 100%;
  height: 100%;
}

.question-detail > p {
  text-align: center;
  float: left;
  margin: 0px;
}

.question-tag {
  width: 54px;
  height: 24px;
  background-color: #4d8eff;
  border-radius: 4px;
  float: left;
  color: #ffffff;
  text-align: center;
  margin-left: 10px;
}

.question-two-tag {
  width: 54px;
  height: 24px;
  background-color: #f18b3b;
  border-radius: 4px;
  float: left;
  color: #ffffff;
  text-align: center;
  margin-left: 10px;
}

.question-three-tag {
  width: 54px;
  height: 24px;
  background-color: #ee6464;
  border-radius: 4px;
  float: left;
  color: #ffffff;
  text-align: center;
  margin-left: 10px;
}

.question-detail {
  width: 160px;
  margin: 20px auto;
  overflow: hidden;
}

.question-ts {
  width: 280px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  background-color: #eff4fa;
  border-radius: 10px;
  color: #222222;
}

.service {
  overflow: hidden;
  background-color: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(194, 200, 211, 0.14);
  border-radius: 10px;
  margin-top: 10px;
  padding: 0 25px;
}

//定制版CSS
.aisino-box {
  overflow: hidden;
  width: 100%;
  // margin-bottom: 20px;
  display: grid;
  grid-template-rows: 1fr auto;
  border-right: solid 1px #dcdcdc;
}
.aisino-service {
  overflow: hidden;
  background-color: #ffffff;
  // box-shadow: 0px 2px 6px 0px rgba(194, 200, 211, 0.14);
  // border-radius: 10px;
  // margin-top: 10px;
  padding: 0 25px;
}
</style>
